import { render, staticRenderFns } from "./ItemViewer.vue?vue&type=template&id=35113605&scoped=true&"
import script from "./ItemViewer.vue?vue&type=script&lang=js&"
export * from "./ItemViewer.vue?vue&type=script&lang=js&"
import style0 from "./ItemViewer.vue?vue&type=style&index=0&id=35113605&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35113605",
  null
  
)

export default component.exports